"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recordedEventKeys = exports.recordedEventKeysEnabled = exports.storageKey = exports.hamplitudeKey = exports.hstcKey = exports.debugKey = exports.accountId = void 0;
var accountId = 53;
exports.accountId = accountId;
var debugKey = 'USAGE_TRACKER_JS';
exports.debugKey = debugKey;
var hstcKey = '__hstc';
exports.hstcKey = hstcKey;
var hamplitudeKey = '__hmpl';
exports.hamplitudeKey = hamplitudeKey;
var storageKey = "HUBLYTICS_EVENTS_" + accountId;
exports.storageKey = storageKey;
var recordedEventKeysEnabled = 'USAGE_TRACKER_JS_RECORDER_ENABLED';
exports.recordedEventKeysEnabled = recordedEventKeysEnabled;
var recordedEventKeys = 'USAGE_TRACKER_JS_RECORDED_EVENT_KEYS';
exports.recordedEventKeys = recordedEventKeys;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.376/js/storageKeys.js
// module id = 34
// module chunks = 0